module.exports = __webpack_public_path__ + "static/media/close-icon.40a643a2.svg";